import { Show } from "@clerk/react"
import { createFileRoute } from "@tanstack/react-router"
import { FullCaptureUI } from "@/components/capture-form"
import { PageShell } from "@/components/page-shell"

export const Route = createFileRoute("/_app/capture")({
  component: CapturePage,
})

function CapturePage() {
  return (
    <>
      <Show when="signed-out">
        <p className="text-sm text-muted-foreground p-6">Sign in to capture.</p>
      </Show>
      <Show when="signed-in">
        <PageShell maxWidth="wide">
          <div className="rounded-2xl border shadow-sm">
            <FullCaptureUI />
          </div>
        </PageShell>
      </Show>
    </>
  )
}
